/**
 * The range for a company's default markup percentages (company_settings.material_markup and
 * .subcontractor_markup), and the one message for breaking it.
 *
 * Both columns are numeric(5,2) with no CHECK (verified live 2026-10-29), so 999.99 is the
 * largest value they can hold. This is the STORAGE bound, not a judgement about pricing: a
 * 200-300% parts markup is normal in the trades. Onboarding (PricingSetupStep) already used
 * 999.99; Settings -> Rates & Pricing capped markups at 100 (a rule written for discounts),
 * which refused values onboarding had accepted and blocked saving every other rate on the tab.
 * Both editors now use this.
 */
export const MARKUP_PERCENT_MIN = 0;
export const MARKUP_PERCENT_MAX = 999.99;

/** Returns an error message, or null when the value is acceptable. Empty is left to the caller. */
export const markupPercentError = (value, label = 'Markup') => {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return `${label} must be a number`;
  if (n < MARKUP_PERCENT_MIN) return `${label} cannot be negative`;
  if (n > MARKUP_PERCENT_MAX) return `${label} must be ${MARKUP_PERCENT_MAX}% or less`;
  return null;
};
